import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useStreetViewPanoramaLocation } from '~/_shared/components/streetViewPanorama/useStreetViewPanoramaLocation';
import { noop } from '~/_shared/utils/function.helpers';
import { useLocationImageGallery } from '~/customizeLocationPanel/useLocationImageGallery';
import { useActivePlaceSelector } from '~/store/frontendState/activeMapElements/activeMapElements.selectors';
import { frontendStateStreetViewSet } from '~/store/frontendState/mapTools/streetView/streetView.actionCreators';
import { useGetPlaceFromActivePlace } from '../../mapTools/placesTool/hooks/useGetPlaceFromActivePlace';
import { PlaceDetailsComponent } from './placeDetails.component';

export const PlaceDetailsContainer = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const dispatch = useDispatch();
  const activePlace = useActivePlaceSelector();

  const {
    placeDataLoaded,
    place,
    placeIndex,
    placeSearch,
  } = useGetPlaceFromActivePlace(activePlace);

  const {
    streetViewLocation,
    isLoading: streetViewLocationLoading,
  } = useStreetViewPanoramaLocation(placeDataLoaded && place ? place.location : null);

  const openStreetView = useCallback(() => {
    if (streetViewLocation) {
      dispatch(frontendStateStreetViewSet(streetViewLocation));
    }
  }, [dispatch, streetViewLocation]);

  const gallery = useLocationImageGallery({
    images: [],
    onImageClick: noop,
    onStreetViewClick: openStreetView,
    streetViewLocation: !streetViewLocationLoading ? streetViewLocation : null,
  });

  if (!placeDataLoaded || !placeSearch || !place) {
    return null;
  }

  return (
    <PlaceDetailsComponent
      placeSearch={placeSearch}
      placeIndex={placeIndex}
      place={place}
      onClose={onClose}
      onExpandClick={openStreetView}
      gallery={gallery.galleryItems.length > 0 ? gallery : undefined}
    />
  );
};
